<template>
  <div class="clues-add">
    <el-dialog
      class="record-add"
      width="1300px"
      title="新增报销"
      :visible.sync="showAdd"
      :modal-append-to-body="false"
      @close="close"
    >
      <el-form v-if="showAdd" :inline="true" :model="params" ref="ruleForm" label-width="140px" label-position="right" :rules="rules">
        <el-form-item label="报销事项" prop="applyItemId">
          <el-select v-model="params.applyItemId" placeholder="点击选择报销事项">
            <el-option v-for="item in source" :key="item.id" :label="item.name" :value="item.id"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="报销金额" prop="money">
          <el-input
            type="number"
            @blur="getValueData"
            min="0"
            onkeyup="this.value = this.value.replace(/[^\d.]/g,'').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^\./g, '')"
            v-model="params.money"
            placeholder="请输入报销金额"
            style="width: 220px"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="凭证" prop="photo">
          <el-upload
            class="upload-demo"
            :action="`${baseURL}/api/Alioss/uploadTotal`"
            :on-preview="handlePreview"
            :on-remove="handleRemoves"
            :before-remove="beforeRemove"
            :before-upload="beforeUpload"
            accept=".jpg, .png"
            multiple
            :limit="9"
            list-type="picture"
            :on-exceed="handleExceed"
            :on-success="chenggong"
            :file-list="fileList"
          >
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">
              只能上传jpg/png文件，且不超过500kb
            </div>
          </el-upload>
        </el-form-item>
        <el-form-item label="收款人" prop="payee_account">
          <el-button style="padding:0 20px!important;width:auto !important;" @click="onSubmit = true">选择收款账户 </el-button>
          <el-button style="padding:0 20px!important;width:auto !important;" class="ipt" :title="person.payee_account" v-if="person.payee_name">{{ person.payee_account }}</el-button>
        </el-form-item>
        <!-- <el-form-item>
        </el-form-item> -->
        <el-form-item label="备注" prop="remark">
          <el-input
            type="textarea"
            v-model="params.remark"
            placeholder="请输入备注信息"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item class="submit" label-width="0"> </el-form-item>
      </el-form>
      <el-divider></el-divider>
      <form-create
        v-model="yulanform"
        :rule="formrule"
        :option="option"
        @on-submit="onSubmit1"
        style="width: 100%;margin-top: 20px;"
      ></form-create>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" :loading="lockAdd" @click="submitForm">保存</el-button>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="previewVisible" title="查看凭证" width="80%">
      <img width="100%" :src="params.photo" alt="" />
    </el-dialog>
    <el-dialog title="选择" :visible.sync="onSubmit" width="700px">
      <el-button style="margin-left:20px" type="primary" @click="(onSubmitn = true),onclear()">添加</el-button>
      <el-table
        border
        :data="tableData"
        style="margin: 20px auto 0  ;width:95%"
        
        highlight-current-row
        @current-change="handleCurrentChange"
      >
        <el-table-column prop="payee_name" label="收款人姓名" align="center"></el-table-column>
        <el-table-column prop="payee_account" label="收款人账号" align="center"></el-table-column>
        <el-table-column prop="bank_information" label="银行卡开户行信息" align="center"></el-table-column>
        <el-table-column prop="type_name" label="支付类别名称" align="center"></el-table-column>
        <el-table-column  width="230" label="操作" align="center">
          <template slot-scope="scope">
            <el-button type="text " size="mini" @click.stop=";(onSubmitns = true), bianji(scope.row)">修改</el-button>
            <el-button size="mini" type="text danger" @click.stop="handleClick(scope.row)">
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="onSubmit = false">取 消</el-button>
      <!--<el-button type="primary" @click="numoo()">确 定</el-button>--->
        
      </span>
    </el-dialog>
    <el-dialog title="添加" :visible.sync="onSubmitn" width="700px">
      <el-form ref="form" :model="form" label-width="140px">
        <el-form-item label="类型" required>
          <el-radio-group v-model="form.type">
            <el-radio :label="1">银行卡</el-radio>
            <el-radio :label="2">支付宝</el-radio>
            <el-radio :label="3">微信</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="收款人姓名" required>
          <el-input v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item label="收款人账号" required>
          <el-input v-model="form.payee_account"></el-input>
        </el-form-item>
        <el-form-item label="银行卡开户行信息" required v-if="form.type == 1">
          <el-input v-model="form.bank_information"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="onSubmitn = false">取 消</el-button>
        <el-button type="primary" @click="numooss()">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="修改" :visible.sync="onSubmitns" width="30%">
      <el-form ref="form" :model="forms" label-width="140px">
        <el-form-item label="类型" required>
          <el-radio-group v-model="forms.type">
            <el-radio :label="1">银行卡</el-radio>
            <el-radio :label="2">支付宝</el-radio>
            <el-radio :label="3">微信</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="收款人姓名" required>
          <el-input v-model="forms.name"></el-input>
        </el-form-item>
        <el-form-item label="收款人账号" required>
          <el-input v-model="forms.payee_account"></el-input>
        </el-form-item>
        <el-form-item label="银行卡开户行信息" required v-if="forms.type == 1">
          <el-input v-model="forms.bank_information"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="onSubmitns = false">取 消</el-button>
        <el-button type="primary" @click="numoossn()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { addApplyExpense, getApplyItemList } from '@/api/applyExpense.js'
import qs from 'qs'
export default {
  name: 'reimbursementAdd',
  inject: ['reload'],
  data() {
    return {
      showAdd: false,
      id: 0,
      module: '',
      rules: {
        applyItemId: [{ required: true, message: '请选择报销事项', trigger: ['blur', 'change'] }],
        money: [{ required: true,  message: '请输入报销金额', trigger: ['blur', 'change'] }],
        photo: [{ required: true,  message: '请上传报销凭证', trigger: ['blur', 'change'] }],
        payee_account: [{ required: true, message: '请选择收款人账号', trigger: ['blur', 'change'] }]
      },
      params: {
        applyItemId: '',
        money: '',
        photo: '',
        payee_account: '',
        remark: ''
      },
      source: [],
      previewVisible: false,
      disabled: false,
      lockAdd: false,
      onSubmit: false,
      onSubmitn: false,
      onSubmitns: false,
      tableData: {},
      form: {
        name: '',
        type: '',
        payee_account: '',
        bank_information: ''
      },
      forms: {
        name: '',
        type: '',
        payee_account: '',
        bank_information: '',
        id: ''
      },
      person: {},
      baseURL: this.axios.defaults.baseURL,
      fileList: [],
      url: '',
      yulanform: '',
      formrule: [],
      option: {
        submitBtn: {
          show: false
        }
      },
      fie: [],
      custom_field: {},
      numMoney: 0
    }
  },
  
  
  methods: {
    
    chenggong(response, file, fileList) {
      var arr = []
      fileList.map(i => {
        arr.push(i.response.data.url)
      })
      this.url = arr.toString()
      this.params.photo = arr.toString()
    },
    handlePreview(file) {
      console.log(file)
    },
    /* beforeupload  返回false  会自动调用beforeRemove handleRemoves */
    handleRemoves(file, fileList) {
      if (file && file.status==="success") {
        console.log(file, fileList)
      }
    },
    handleExceed() {
      this.$message.warning(
        `当前限制选择 9 个文件，如需更换请先删除`
      )
    },
    /*
    numoo() {
      this.$message({
        message: '请选择账户',
        type: 'none'
      })
    },*/
    /* beforeupload  返回false  会自动调用beforeRemove handleRemoves */
    beforeRemove(file, fileList) {
      if (file && file.status==="success") {
          console.log(fileList)
          return this.$confirm(`确定移除 ${file.name}？`)
      }
      
    },
    handleCurrentChange(val) {
      this.person = val
      this.onSubmit = false
      this.params.payee_account = val.payee_account
    },
    bianji(val) {
      
      this.forms.name = val.payee_name
      this.forms.payee_account = val.payee_account
      this.forms.bank_information = val.bank_information
      this.forms.type = val.type
      this.forms.id = val.id
      if(this.forms.type != 1){
              this.forms.bank_information = ''
            }
    },
    async handleClick(val) {
      this.$confirm('此操作将删除该条数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.axios
            .post(
              '/crm/Mymine/deleteSessionUserInfo',
              qs.stringify({
                userid: this.$store.state.user.token.userid,
                id: val.id
              }),
              {
                headers: {
                  'Content-Type': 'application/x-www-form-urlencoded'
                }
              }
            )
            .then(res => {
              if (res.code == 1) {
                this.$message({
                  message: res.msg,
                  type: 'success'
                })
                this.getSessionUserInfos()
              }
            })
            .catch(function(err) {
              console.log(err)
            })
        })
        .catch(() => {})
    },
    /*修改 */
    async numoossn() {
      if(this.forms.name.trim() == ''){
        this.$message.error('收款人姓名不能为空')
        return
      }
      if(this.forms.payee_account.trim() == ''){
        this.$message.error('收款人账号不能为空')
        return
      }
      if(this.forms.bank_information.trim() == ''&& this.forms.type == 1){
        this.$message.error('银行卡开户行信息不能为空')
        return
      }
      this.axios
        .post(
          '/crm/Mymine/updateSessionUserInfo',
          qs.stringify({
            account_id: this.$store.state.user.token.account_id,
            userid: this.$store.state.user.token.userid,
            payee_name: this.forms.name,
            payee_account: this.forms.payee_account,
            bank_information: this.forms.bank_information,
            type: this.forms.type,
            id: this.forms.id
          }),
          { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
        )
        .then(res => {
          
          if (res.code == 1) {
            this.onSubmitns = false
            this.onSubmit = true
            this.$message({
              message: res.msg,
              type: 'success'
            })
            
            this.getSessionUserInfos()
          } else if (res.code == 0) {
            this.onSubmitns = true
          }
        })
        .catch(function(err) {
          console.log(err)
        })
    },
    /* 添加*/
    async numooss() {
      if(this.form.name.trim() == ''){
        this.$message.error('请填写收款人姓名')
        return
      }
      if(this.form.payee_account.trim() == ''){
        this.$message.error('请填写收款人账号')
        return
      }
      if(this.form.bank_information.trim() == ''&& this.form.type == 1){
        this.$message.error('请填写银行卡开户行信息')
        return
      }
      this.axios
        .post(
          '/crm/Mymine/addSessionUserInfo',
          qs.stringify({
            account_id: this.$store.state.user.token.account_id,
            userid: this.$store.state.user.token.userid,
            payee_name: this.form.name,
            payee_account: this.form.payee_account,
            bank_information: this.form.bank_information,
            type: this.form.type
          }),
          { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
        )
        .then(res => {
          if (res.code == 1) {
            this.onSubmitn = false
            this.$message({
              message: res.msg,
              type: 'success'
            })
            
            this.getSessionUserInfos()
          } else if (res.code == 0) {
            this.onSubmitn = true
          }
        })
        .catch(function(err) {
          console.log(err)
        })
    },
    async getSessionUserInfos() {
      this.axios
        .post(
          '/crm/Mymine/getSessionUserInfos',
          qs.stringify({
            account_id: this.$store.state.user.token.account_id,
            userid: this.$store.state.user.token.userid
          }),
          { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
        )
        .then(res => {
          this.tableData = res.data
        })
        .catch(function(err) {
          console.log(err)
        })
    },
    async getSource() {
      const source = await getApplyItemList({
        account_id: this.$store.state.user.token.account_id,
        userid: this.$store.state.user.token.userid
      })
      this.source = source.data
    },
    handleSuccess(response) {
      this.$message({
        message: response.msg,
        type: 'success'
      })
      console.log(response)
      this.params.photo = response.data.url
    },
    // handleRemove() {
    //   this.$refs.uploadPhoto.clearFiles()
    // },
    handlePictureCardPreview() {
      this.previewVisible = true
    },
    async onSave() {
      let selfSub = {}
      for (let i in this.custom_field) {
        this.fie.push(i)
      }
      for (let i = 0; i < this.fie.length; i++) {
        for (let j = 0; j < this.formrule.length; j++) {
          if (this.formrule[j].field == this.fie[i]) {
            this.$set(selfSub, this.fie[i], this.formrule[j])
          }
        }
      }
      const returnMoney = {
        account_id: this.$store.state.user.token.account_id,
        userid: this.$store.state.user.token.userid,
        apply_item_id: this.params.applyItemId,
        payee_account: this.person.payee_account,
        remark: this.params.remark,
        lower_money: this.params.money,
        photo: this.url,
        type: this.person.type,
        payee_name: this.person.payee_name,
        bank_information: this.person.bank_information,
        self_content: JSON.stringify(selfSub)
      }
      this.lockAdd = true
      const res = await addApplyExpense(returnMoney)
      if (res.code == 1) {
        this.$message.success(res.msg)
        this.reload()
      }
      this.lockAdd = false
    },
    open() {
      this.showAdd = true
      this.initData()
      this.getSource()
      this.getSessionUserInfos()
      this.getField()
    },
    close() {
      this.showAdd = false
    },
    submitForm() {
      this.$refs['ruleForm'].validate(valid => {
        if (valid) {
          this.onSave()
          return true
        } else {
          return false
        }
      })
    },
    initData() {
      this.returnMoney = {
        apply_item_id: '',
        money: '',
        photo: '',
        payee_account: ''
      }
    },
    async getField() {
      const res = await this.axios({
        url: '/crm/ApplyExpense/get_custom_filed',
        method: 'POST',
        data: {
          account_id: this.$store.state.user.token.account_id,
          state: 'applyExpense'
        }
      })
      if (res.code == 1) {
        this.custom_field = res.data.custom_field
        let arr = []
        this.formrule = []
        for (let i in this.custom_field) {
          arr.push(this.custom_field[i])
        }
        arr.forEach(item => {
          if (!item.if_show) {
            item.display = item.if_show
          }
          this.formrule = arr
        })
      }
    },
    onSubmit1(formData) {
      alert(JSON.stringify(formData))
    },
    /*只允许金额为数字*/
    getValueData() {
      if (this.numMoney) {
        let a = this.numMoney.substring(0, 1)
        let b = this.numMoney.substring(1, 2)
        if (a == '0' && b != '.') {
          this.numMoney = this.numMoney.slice(1)
        }
      }
    },
    onclear(){
      this.form.name = ''
      this.form.payee_account =''
      this.form.bank_information =''
      this.form.type =''
    },
    beforeUpload(file) {
        const isJPG = file.type === 'image/jpeg';
        const isPNG = file.type === 'image/png';
        const isLt2M = file.size /1024 < 500;

        if (!isJPG&&!isPNG) {
          this.$message.error('上传头像图片只能是 jpg 或 png 格式!');
          this.fileList = []
          return
        }
        if (!isLt2M) {
          this.$message.error('上传头像图片大小不能超过 500KB!');
          this.fileList = []
          return
        }
        //return isJPG && isLt2M;
      }
    
  }
}
</script>
<style lang="scss" scoped>
.submit {
  margin-top: 50px;
  display: flex;
  justify-content: center;
}
.ipt {
  text-overflow: ellipsis;
  max-width: 220px;
  overflow: hidden;
  white-space: nowrap; 
}
::v-deep .cooperation input {
  cursor: pointer;
}
.btn-box{
  border-radius: 20px;
  width: 100px;
  border: 0px ; 
  height: 100%;
  border: 1px solid #e6e6e6;
  display: flex;
  align-items: center;

}
.btn-box>span{
    height: 25px;
    background: #e6e6e6;
    width: 1px;
}
.add-btn {
  margin-left: 0px;
  margin-right:0px;
  height: 100%;
  width: 50% !important;
  border: none;
  background: none;
}

.phone {
  margin-top: 12px;
  display: flex;
}

.phone:nth-child(1) {
  margin-top: 6px;
}


.el-form-item{
  width:50%;
}
::v-deep .el-form--inline .el-form-item{
  margin-right: 0px;
  margin-bottom: 30px;
}
.el-divider{
  height: 5px;
  margin: 10px 0;
}
::v-deep .form-create .el-form-item__label { 
  width:14rem !important;}
::v-deep .form-create .el-input-item__content>.el-input,
.el-dialog .el-select,
 .el-dialog .el-input{
  width:470px !important;
}
.el-input__inner{
  border-color: #e6e6e6;
  border-radius: 8px;
  
}
.phone .el-input__inner,
.phone .el-input{
  width:330px !important;
  margin-right: 20px;
  
}
::v-deep .el-col-24 {
    width: 50%;
}
</style>
